"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.typographyShadeKeys = exports.typographyColors = exports.typographyColorKeys = void 0;

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _pick = _interopRequireDefault(require("lodash/pick"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _styledComponents = require("styled-components");

var _utils = require("../../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    keys.push.apply(keys, Object.getOwnPropertySymbols(object));
  }

  if (enumerableOnly) keys = keys.filter(function (sym) {
    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
  });
  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var base = _color.default.base,
    status = _color.default.status;
var enabledBaseColors = (0, _pick.default)(base, ['charcoal', 'alaskanHusky', 'snowWhite', 'quarterMoon', 'halfMoon', 'fullMoon']);
var passThroughColors = {
  inherit: 'inherit'
};
var enabledBaseColorKeys = Object.keys(enabledBaseColors);
var statusColorKeys = Object.keys(status).filter(function (k) {
  return k !== 'default';
});
var passThroughColorKeys = Object.keys(passThroughColors);
var statusColors = statusColorKeys.reduce(function (acc, k) {
  return _objectSpread({}, acc, _defineProperty({}, k, status[k].medium));
}, {});
var typographyColorKeys = [].concat(_toConsumableArray(enabledBaseColorKeys), _toConsumableArray(statusColorKeys), _toConsumableArray(passThroughColorKeys));
exports.typographyColorKeys = typographyColorKeys;

var typographyColors = _objectSpread({}, enabledBaseColors, {}, statusColors, {}, passThroughColors);

exports.typographyColors = typographyColors;
var lightThemeShades = {
  0: base.charcoal,
  1: base.alaskanHusky,
  2: base.snowWhite
};
var darkThemeShades = {
  0: base.snowWhite,
  1: base.quarterMoon,
  2: base.alaskanHusky
};
var shadesForMode = {
  dark: darkThemeShades,
  light: lightThemeShades
}; // Object.keys always returns strings (even for numbers). keyof may also return numbers.

var typographyShadeKeys = Object.keys(lightThemeShades).map(function (k) {
  return parseInt(k, 10);
});
exports.typographyShadeKeys = typographyShadeKeys;
var defaultShadeMode = 'light';
var shadeModifiers = (0, _utils.applyDynamicModifiers)('shade', function (_ref) {
  var _ref$theme$mode = _ref.theme.mode,
      mode = _ref$theme$mode === void 0 ? defaultShadeMode : _ref$theme$mode,
      _ref$shade = _ref.shade,
      shade = _ref$shade === void 0 ? 0 : _ref$shade;
  var shades = shadesForMode[mode];
  var selectedShade = shades && shades[shade];
  return selectedShade ? (0, _styledComponents.css)(["color:", ";"], (0, _toColorString.default)(selectedShade)) : '';
});
var predefinedColorKeys = [].concat(_toConsumableArray(enabledBaseColorKeys), _toConsumableArray(statusColorKeys));
var colorModifiers = (0, _utils.applyDynamicModifiers)('color', function (_ref2) {
  var colorProp = _ref2.color;
  return colorProp ? (0, _styledComponents.css)(["color:", ";"], predefinedColorKeys.includes(colorProp) ? (0, _toColorString.default)(typographyColors[colorProp]) : colorProp) : '';
});
var withColors = (0, _styledComponents.css)(["", ";", ";"], shadeModifiers, colorModifiers);
var _default = withColors;
exports.default = _default;